import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import MuiButton from "@material-ui/core/Button"
import RefreshIcon from "@material-ui/icons/Refresh"

const useStyles = makeStyles((theme) => ({
  root: {},
  spinner: {
    marginRight: theme.spacing(1),
    top: 2,
    animation: `$spin 1500ms infinite linear`,
  },
  "@keyframes spin": {
    from: {
      transform: "rotate(0deg)",
    },
    to: {
      transform: "rotate(360deg)",
    },
  },
}))

export default function Button({
  isLoading = false,
  disabled = false,
  startIcon,
  endIcon,
  color,
  children,
  ...props
}) {
  const classes = useStyles()

  return (
    <MuiButton
      className={classes.root}
      disabled={disabled || isLoading}
      startIcon={startIcon && isLoading ? <RefreshIcon className={classes.spinner} /> : startIcon}
      endIcon={endIcon && isLoading ? <RefreshIcon className={classes.spinner} /> : endIcon}
      variant="contained"
      color={color || "secondary"}
      {...props}
    >
      {children}
    </MuiButton>
  )
}
